import type { OnboardingStep } from '../onboarding-steps';

export type PanelCard = 'brand' | 'collabs' | 'sales';

/** done: built; current: being built on this step; upcoming: not reached yet. */
export type PanelCardState = 'done' | 'current' | 'upcoming';

/** The step each card is built on, in the order of the mock-up. */
const CARD_STEPS: Record<PanelCard, OnboardingStep[]> = {
  brand: ['brand'],
  collabs: ['collabs'],
  sales: ['sales', 'connect'],
};

const STEP_ORDER: OnboardingStep[] = [
  'brand',
  'creators',
  'collabs',
  'sales',
  'connect',
  'welcome',
];

export function panelCardState(card: PanelCard, step: OnboardingStep): PanelCardState {
  const steps = CARD_STEPS[card];
  if (steps.includes(step)) return 'current';

  const lastStepOfCard = STEP_ORDER.indexOf(steps[steps.length - 1]);
  return STEP_ORDER.indexOf(step) > lastStepOfCard ? 'done' : 'upcoming';
}

/** The pill naming the part of the brand space each step builds. */
export function panelPillKey(step: OnboardingStep): string {
  switch (step) {
    case 'brand':
      return 'onboarding.brandPanel.pill.brand';
    case 'creators':
      return 'settings.agents.title';
    case 'collabs':
      return 'onboarding.brandPanel.pill.collabs';
    case 'sales':
    case 'connect':
      return 'onboarding.brandPanel.pill.sales';
    case 'welcome':
      return 'onboarding.brandPanel.pill.done';
  }
}

/**
 * The creators step and the welcome page show the Companion's example creators
 * instead of the stacked cards of the brand space (mock-up v3).
 */
export const panelShowsCompanion = (step: OnboardingStep): step is 'creators' | 'welcome' =>
  step === 'creators' || step === 'welcome';
